module.exports = __webpack_public_path__ + "img/Icon_nfc-card-hand.2ccbb63a.png";